module.exports = __webpack_public_path__ + "media/12_8.82043507.wav";